import { render, staticRenderFns } from "./VentaCredito.vue?vue&type=template&id=53635436&"
import script from "./VentaCredito.vue?vue&type=script&lang=js&"
export * from "./VentaCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports